import { cx } from "../utils/cx";

export interface SpinnerProps {
  readonly className?: string;
  /** Accessible label; omit when a parent already announces busy state. */
  readonly label?: string;
}

export function Spinner({ className, label }: SpinnerProps) {
  return (
    <span
      className={cx("ui-spinner", className)}
      role={label ? "status" : undefined}
      aria-hidden={label ? undefined : true}
    >
      {label ? <span className="ui-visually-hidden">{label}</span> : null}
    </span>
  );
}
